import React, { useState } from 'react';
import API from '../api';
import { useNavigate } from 'react-router-dom';
import AuthNavbar from '../components/AuthNavbar'; 
import Footer from '../components/Footer'; 
import './Register.css'; 

const Register = () => {
  // --- NEW STATES FOR OTP FLOW ---
  const [step, setStep] = useState(1); // Step 1: Registration Form, Step 2: OTP Verification
  const [otp, setOtp] = useState('');

  const [formData, setFormData] = useState({ 
    name: '', 
    email: '', 
    password: '', 
    role: 'user', 
    phone: '' 
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();

  // STEP 1: Submit initial details to get the OTP emailed
  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await API.post('/auth/register', formData);
      alert("Verification code sent to your email!");
      setStep(2); // Move to OTP screen instead of success modal
    } catch (err) {
      alert(err.response?.data?.msg || "Registration Failed");
    }
  };

  // STEP 2: Submit the OTP to verify the account
  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    try {
      await API.post('/auth/verify-otp', { email: formData.email, otp });
      
      // If successful, NOW we show the Success Modal
      setShowSuccess(true);

      // Wait 3 seconds to let them read before going to login
      setTimeout(() => {
        navigate('/');
      }, 3000);

    } catch (err) {
      alert(err.response?.data?.msg || "Invalid OTP or OTP Expired");
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AuthNavbar />
      
      <div className="register-page-container" style={{ flex: 1, padding: '0.5rem 1rem 2rem' }}>
        <div className="hero-content">
          <div className="status-badge">
            <span className="icon">🚀</span> Join the Network
          </div>
          <h1>Ready to get started?</h1>
          <h1 className="highlight-text">
            {step === 1 ? "Create your account." : "Verify your email."}
          </h1>
          <p className="description">
            {step === 1 
              ? "Whether you're a driver in need or a mechanic ready to help, join OnRoad Assist for reliable roadside support." 
              : `We have sent a 6-digit verification code to ${formData.email}. Please enter it below.`}
          </p>
        </div>

        <div className="register-form-card">
          {/* CONDITIONALLY RENDER FORMS BASED ON STEP */}
          
          {step === 1 ? (
            /* --- REGISTRATION FORM --- */
            <form onSubmit={handleRegister} className="form-stack">
              <input 
                type="text" 
                placeholder="Full Name" 
                className="styled-input"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})} 
                required 
              />
              <input 
                type="email" 
                placeholder="Email Address" 
                className="styled-input"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})} 
                required 
              />
              <input 
                type="password" 
                placeholder="Create Password" 
                className="styled-input"
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})} 
                required 
              />
              <input 
                type="text" 
                placeholder="Phone Number" 
                className="styled-input"
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})} 
                required
              />
              
              <div className="select-wrapper">
                <label className="input-label">I am a:</label>
                <select 
                  className="styled-select"
                  value={formData.role}
                  onChange={(e) => setFormData({...formData, role: e.target.value})}
                >
                  <option value="user">User / Driver (Seeking Help)</option>
                  <option value="mechanic">Mechanic (Providing Help)</option>
                </select>
              </div>
              
              <div className="action-buttons">
                <button type="submit" className="btn-solid-blue">Create Account</button>
                <button 
                  type="button" 
                  className="btn-outline-gray" 
                  onClick={() => navigate('/')}
                >
                  Back to Login
                </button>
              </div>
            </form>

          ) : (

            /* --- OTP VERIFICATION FORM --- */
            <form onSubmit={handleVerifyOTP} className="form-stack" style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '40px', marginBottom: '10px' }}>✉️</div>
              <input 
                type="text" 
                placeholder="Enter 6-Digit Code" 
                className="styled-input"
                style={{ textAlign: 'center', fontSize: '20px', letterSpacing: '4px', fontWeight: 'bold' }}
                value={otp}
                onChange={(e) => setOtp(e.target.value)} 
                maxLength="6"
                required 
              />
              
              <div className="action-buttons" style={{ marginTop: '20px' }}>
                <button type="submit" className="btn-success" style={{ width: '100%', padding: '12px', fontSize: '16px' }}>
                  Verify Email
                </button>
                <button 
                  type="button" 
                  className="btn-outline-gray" 
                  onClick={() => setStep(1)} // Lets them go back if they made a typo in their email
                  style={{ width: '100%', marginTop: '10px' }}
                >
                  Back
                </button>
              </div>
            </form>
          )}
        </div>
      </div>

      {/* SUCCESS MODAL POP-UP */}
      {showSuccess && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ textAlign: 'center', borderTop: '8px solid #28a745' }}>
            <div style={{ fontSize: '50px', color: '#28a745', marginBottom: '10px' }}>✅</div>
            <h2 style={{ margin: '0' }}>Account Created!</h2>
            <p style={{ color: '#666', border: 'none', marginTop: '10px' }}>
              Welcome to OnRoad Assist, <strong>{formData.name}</strong>.
            </p>
            
            {formData.role === 'mechanic' ? (
              <p style={{ fontSize: '14px', color: '#856404', background: '#fff3cd', padding: '10px', borderRadius: '5px', border: 'none' }}>
                <strong>Note:</strong> Your mechanic account is pending Admin approval. You can login once approved.
              </p>
            ) : (
              <p style={{ fontSize: '14px', color: '#888', border: 'none' }}>Redirecting you to the login page...</p>
            )}
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Register;